import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FaCheck } from 'react-icons/fa';
import fnc from '../mymod/commFunction';
import './FindModals.scss';

const VERIFY_SECONDS = 5 * 60;

const FindIdModal = ({ onClose }) => {
  const [hp, setHp] = useState('');
  const [code, setCode] = useState('');
  const [codeSent, setCodeSent] = useState(false);
  const [foundId, setFoundId] = useState('');
  const [timeLeft, setTimeLeft] = useState(0);
  const [sending, setSending] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      clearInterval(timerRef.current);
    };
  }, [onClose]);

  function startTimer() {
    clearInterval(timerRef.current);
    setTimeLeft(VERIFY_SECONDS);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) { clearInterval(timerRef.current); return 0; }
        return prev - 1;
      });
    }, 1000);
  }

  function formatTime(sec) {
    return `${String(Math.floor(sec / 60)).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
  }

  function handleSend(e) {
    e.preventDefault();
    if (!hp.trim()) { alert('휴대폰 번호를 입력해주세요.'); return; }
    setSending(true);
    fnc.sendAxios('/findIdRoutes/sendVerifyCode', { hp: hp.trim() }, (res) => {
      setSending(false);
      if (res.error) { alert(res.message || '인증번호 전송 실패'); return; }
      setCodeSent(true);
      setCode('');
      setFoundId('');
      startTimer();
    });
  }

  function handleVerify(e) {
    e.preventDefault();
    if (!code.trim()) { alert('인증번호를 입력해주세요.'); return; }
    if (timeLeft === 0) { alert('인증번호가 만료되었습니다. 다시 요청해주세요.'); return; }
    fnc.sendAxios('/findIdRoutes/findId', { hp: hp.trim(), code: code.trim() }, (res) => {
      if (res.error) { alert(res.message || '인증 실패'); return; }
      clearInterval(timerRef.current);
      setFoundId(res.id || '');
    });
  }

  const step = foundId ? 3 : codeSent ? 2 : 1;

  return createPortal(
    <div className='find-modal-overlay'>
      <div className='find-modal'>
        <div className='modal-header'>
          <h3>아이디 찾기</h3>
          <button className='btn-close' type='button' onClick={onClose}>✕</button>
        </div>

        <div className='modal-body'>
          {/* 단계 표시 */}
          <div className='step-indicator'>
            <div className={`step-dot ${step >= 1 ? 'done' : ''} ${step === 1 ? 'active' : ''}`}>
              <span>1</span><em>번호 입력</em>
            </div>
            <div className={`step-line ${step >= 2 ? 'done' : ''}`} />
            <div className={`step-dot ${step >= 2 ? 'done' : ''} ${step === 2 ? 'active' : ''}`}>
              <span>2</span><em>인증번호</em>
            </div>
            <div className={`step-line ${step >= 3 ? 'done' : ''}`} />
            <div className={`step-dot ${step >= 3 ? 'done' : ''}`}>
              <span>{step === 3 ? <FaCheck /> : '3'}</span><em>완료</em>
            </div>
          </div>

          {/* STEP 1 - 번호 입력 */}
          {step < 3 && (
            <div className='field-block'>
              <label>*휴대폰 번호</label>
              <form onSubmit={handleSend} className='field-row'>
                <input
                  type='tel'
                  value={hp}
                  onChange={(e) => { setHp(e.target.value); setCodeSent(false); clearInterval(timerRef.current); setTimeLeft(0); }}
                  placeholder='01012345678'
                  maxLength={11}
                  disabled={codeSent && timeLeft > 0}
                />
                <button
                  type='submit'
                  className='btn-send'
                  disabled={sending || (codeSent && timeLeft > 0)}
                >
                  {sending ? '전송중...' : codeSent ? '재전송' : '전송'}
                </button>
              </form>
              {codeSent && timeLeft > 0 && <p className='sent-notice'>인증번호가 발송되었습니다.</p>}
            </div>
          )}

          {/* STEP 2 - 인증번호 */}
          {codeSent && step < 3 && (
            <div className='field-block'>
              <label>인증번호</label>
              <form onSubmit={handleVerify} className='field-row'>
                <div className='code-wrap'>
                  <input
                    type='text'
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder='6자리 입력'
                    maxLength={6}
                  />
                  <span className={`timer-badge ${timeLeft <= 60 ? 'urgent' : ''}`}>
                    {timeLeft > 0 ? formatTime(timeLeft) : '만료'}
                  </span>
                </div>
                <button type='submit' className='btn-send'>확인</button>
              </form>
            </div>
          )}

          {/* STEP 3 - 결과 */}
          {step === 3 && (
            <div className='result-panel'>
              <div className='result-icon'><FaCheck /></div>
              <p className='result-label'>회원님의 아이디</p>
              <div className='result-id'>{foundId}</div>
            </div>
          )}
        </div>

        <div className='modal-footer'>
          <button type='button' className='btn-secondary' onClick={onClose}>닫기</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FindIdModal;
